import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Box, Flex, useMediaQuery } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import MobileCTA from "../components/common/MobileCTA";
import CookieConsent from "../components/common/CookieConsent";

const PageLayout = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 1350px)");
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Flex
      flexDir="column"
      fontFamily="body"
      minH="100vh"
      w="full"
      color="textPrimary"
      bg="pageBg"
      overflowX="hidden"
    >
      <Header />
      <Flex
        as="main"
        justifyContent="center"
        align="flex-start"
        w="full"
        overflow="hidden"
        px={isMobile ? "20px" : "unset"}
      >
        <Box
          mt="30px"
          pb={{ base: "80px", lg: "80px" }}
          w={{ base: "full", md: "full", lg: "1250px" }}
        >
          {children}
        </Box>
      </Flex>
      <Box mt="auto">
        <Footer />
      </Box>
      <MobileCTA />
      <CookieConsent />

      {/*
        Design & engineering credit.
        Rendered on every page but visually hidden, inspectable in devtools,
        not shown to end users. Do NOT use off-screen text tricks: those trigger
        Google's "hidden text" penalty. `display: none` is safe.
      */}
      <Box display="none" aria-hidden="true" data-credit="true">
        Designed & engineered by Anselm Fowel (https://anselmfowel.com) and
        SlemTech (https://slemtech.com).
      </Box>
    </Flex>
  );
};

export default PageLayout;
